/* src/app/dashboard/rank/rank.component.scss */
.rank-loading {
  display: flex;
  flex: 1 1 auto;
  justify-content: center;
  align-items: center;
  min-height: 300px;
  padding-top: 20px;
}
.rank-container {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  height: 260px;
}
.main-box {
  padding: 10px 10px;
  box-sizing: border-box;
}
.views {
  display: flex;
  flex: 1 0 33%;
  flex-direction: column;
}
.view-count {
  font-size: 4vw;
  font-weight: bold;
  color: var(--primary-color);
}
.view-title {
  font-size: 2vw;
  color: var(--secondary-color);
}
:host-context(.dark-mode) .view-count {
  color: var(--green-accent) !important;
}
:host-context(.dark-mode) .view-title {
  color: var(--dark-text-color) !important;
}
.gauge {
  flex: 1 0 33%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}
#gauge-image {
  max-width: 100%;
}
.gauge-pointer {
  position: absolute;
  max-height: 100%;
  bottom: 0;
  left: 50%;
  transform-origin: 50% 90%;
  transition: transform 0.5s ease;
}
.titles {
  flex: 1 0 33%;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
}
.rank-image {
  max-width: 100%;
  height: 24px;
  margin-bottom: 10px;
}
.guru-badge {
  width: 72px;
  height: 72px;
  object-fit: contain;
  align-self: center;
  margin-bottom: 12px;
  cursor: pointer;
}
@keyframes grow {
  from {
    transform: scale(0.01);
  }
  to {
    transform: scale(1);
  }
}
.grow-animation {
  animation: grow 500ms forwards;
}
@keyframes growShakeShrink {
  0% {
    transform: scale(0.01);
  }
  50% {
    transform: scale(1);
  }
  65% {
    transform: scale(1.5);
  }
  60%, 70%, 80%, 90% {
    transform: scale(1.5) rotate(10deg);
  }
  66%, 75%, 85%, 95% {
    transform: scale(1.5) rotate(-10deg);
  }
  100% {
    transform: scale(1) rotate(0deg);
    transform: scale(1);
  }
}
.grow-shake-animation {
  animation: growShakeShrink 1500ms forwards;
}
/*# sourceMappingURL=rank.component.css.map */
